var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{ref:"link",on:{"click":_setup.clicked}},[_c('li',[_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.count != null)?_c('span',{staticClass:"count"},[_vm._v("("+_vm._s(_vm.count)+")")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }